'use client'
import MyBlockComponent from './myblock_component';
import React, { useRef } from 'react';
// import Bananas from '@components/home3dBg';
// import Bg from "@components/backgroundEffectsHome"

export default function HomePage({ blocks, locale }) {
    console.log("HOMEPAGE", blocks, locale);
    const gblocks = blocks.blocks;
    const elementRef = useRef();
    return (

        <div ref={elementRef} className="pages relative select-none md:mt-[-25px]">

            {gblocks.map((block, i) => {
                const name = block.blockName && block.blockName.substring(block.blockName.indexOf('/') + 1).replaceAll('-', '_');
                console.log("NAME", name)
                return (
                    <MyBlockComponent key={i} tag={name} block={block.attrs} locale={locale} />
                )
            })}
        </div>

    )
}


